<div class="lk-eu-v2">
<header class="lk-eu-header">
  <div
    class="grid grid-nogutter justify-content-center flex-nowrap w-full"
    style="height: 100%">
    <div class="xl:col-8 md:col-10 col-11">
      <div class="lk-eu-header__row flex flex-nowrap justify-content-between align-items-center pl-2">
        <div class="lk-eu-header__left flex flex-nowrap align-items-center gap-3 flex-1 min-w-0">
          <crm-frm-animated-logo
            class="lk-eu-header__logo"
            [size]="50"></crm-frm-animated-logo>

          @if (!menuLoading) {
            <crm-lk-eu-navbar
              #navbar
              class="lk-eu-header__nav"
              [menuItems]="menuItems"
              (mobileMenuOpenChange)="onNavbarMobileMenuOpenChange()"></crm-lk-eu-navbar>
          } @else {
            <p-skeleton
              width="100%"
              height="40px"></p-skeleton>
          }
        </div>

        <div class="lk-eu-header__right lk-eu-header__utilities flex flex-nowrap align-items-center flex-shrink-0">
          <div class="lk-eu-header__utility-slot lk-eu-header__utility-slot--action">
            <crm-support-modal [isLk]="true"></crm-support-modal>
          </div>
          <span
            class="lk-eu-header__utility-vdivider"
            aria-hidden="true"></span>
          <div class="lk-eu-header__utility-slot lk-eu-header__utility-slot--action">
            <crm-lk-eu-notification-icon
              [isShow]="isShow"
              (openNotifications)="openNotificationSidebar()"
              (openNotificationsWithType)="openNotificationSidebar($event)"></crm-lk-eu-notification-icon>
          </div>
          <span
            class="lk-eu-header__utility-vdivider"
            aria-hidden="true"></span>

          <div
            class="lk-eu-profile lk-eu-profile--compact lk-eu-header__mobile-profile"
            routerLink="/lk/external-user/settings"
            routerLinkActive="lk-eu-profile--active"
            [routerLinkActiveOptions]="{ exact: false }"
            [attr.aria-label]="authService.currentProfile?.name || 'Профиль'">
            <crm-user-avatar
              [user]="authService.currentProfile"
              shape="circle"
              size="large"></crm-user-avatar>
          </div>
          <span
            class="lk-eu-header__utility-vdivider lk-eu-header__utility-vdivider--before-burger"
            aria-hidden="true"></span>

          <div class="lk-eu-header__mobile-burger-slot">
            <button
              type="button"
              id="lk-eu-header-mobile-burger"
              class="lk-eu-header__mobile-burger"
              [attr.aria-expanded]="navbar?.mobileMenuOpen === true"
              aria-controls="lk-eu-nav-menu"
              aria-label="Меню"
              (click)="onMobileNavBurgerClick($event)">
              <i
                class="pi"
                [class.pi-bars]="navbar?.mobileMenuOpen !== true"
                [class.pi-times]="navbar?.mobileMenuOpen === true"
                aria-hidden="true"></i>
            </button>
          </div>

          <div
            class="lk-eu-profile lk-eu-header__desktop-profile"
            routerLink="/lk/external-user/settings"
            routerLinkActive="lk-eu-profile--active"
            [routerLinkActiveOptions]="{ exact: false }">
            <div class="flex flex-nowrap align-items-center gap-2">
              <div>
                <h4 class="text-right mb-0 break-word">{{ authService.currentProfile?.name | truncate: 20 }}</h4>
                <p class="text-sm text-right break-word">{{ authService.currentUser?.job | truncate: 10 }}</p>
              </div>

              <div>
                <crm-user-avatar
                  [user]="authService.currentProfile"
                  shape="circle"
                  size="large"></crm-user-avatar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="lk-eu-body pt-3">
  <crm-lk-eu-notification-panel></crm-lk-eu-notification-panel>
  <div
    class="grid grid-nogutter justify-content-center flex-nowrap w-full"
    style="height: 100%">
    <div class="xl:col-8 md:col-10 col-11">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<crm-lk-eu-notification-sidebar
  (isShowChange)="onNotificationSidebarVisibleChange($event)"
  [selectedInformerType]="selectedInformerType"></crm-lk-eu-notification-sidebar>

<crm-form-sidebar [isLk]="true"></crm-form-sidebar>
</div>
